var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8279 16.5629C14.0343 16.6577 14.2669 16.6794 14.4874 16.6243C14.7078 16.5693 14.9029 16.4408 15.0405 16.26L15.3954 15.7951C15.5816 15.5468 15.8231 15.3453 16.1007 15.2065C16.3784 15.0677 16.6845 14.9954 16.9949 14.9954H19.994C20.5242 14.9954 21.0328 15.206 21.4077 15.581C21.7827 15.956 21.9934 16.4645 21.9934 16.9948V19.9938C21.9934 20.5241 21.7827 21.0327 21.4077 21.4076C21.0328 21.7826 20.5242 21.9932 19.994 21.9932C15.2215 21.9932 10.6446 20.0974 7.26997 16.7228C3.89535 13.3482 1.99951 8.7712 1.99951 3.99877C1.99951 3.4685 2.21016 2.95995 2.58512 2.585C2.96007 2.21004 3.46863 1.99939 3.9989 1.99939H6.99797C7.52824 1.99939 8.03679 2.21004 8.41175 2.585C8.78671 2.95995 8.99736 3.4685 8.99736 3.99877V6.99785C8.99736 7.30824 8.92509 7.61438 8.78628 7.892C8.64746 8.16963 8.44592 8.41112 8.1976 8.59736L7.72975 8.94825C7.54622 9.08838 7.41686 9.28773 7.36365 9.51243C7.31044 9.73712 7.33665 9.97331 7.43784 10.1809C8.8041 12.9559 11.0511 15.2001 13.8279 16.5629Z",
    stroke: "#155DFC",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0ca8406d0d0668730ef6dd0c668be657.svg";
export { ForwardRef as ReactComponent };